module.exports = __webpack_public_path__ + "assets/img/block-right-c5e01a86.png";